<template>
<div>
  <el-row>
    <el-col :span="17">
  <!-- 面包屑导航区域-->
  <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item :to="{ path: '/home' }">Homepage</el-breadcrumb-item>
    <el-breadcrumb-item>Logistic</el-breadcrumb-item>
    <el-breadcrumb-item>Cargo Creation</el-breadcrumb-item>
  </el-breadcrumb>
</el-col>
  <!--<el-col class="el-breadcrumb__inner" font-size="3px" :span="6">
    Updating Time: {{ this.updateTime }}
    </el-col>-->
  </el-row>
  <!--卡片视图区域:model="formInline"-->

  <el-card>
    <el-form  class="demo-form-inline">
      <!--IP user-->
    <div v-if="this.userName.toUpperCase()==='IP' || this.userName.toUpperCase()==='J3P'">
<el-row>
<el-col :span = "6">
      <el-form-item label="Status:" label-width="115px">
            <el-select v-model="formInline.status" multiple collapse-tags
              style="margin-left: 0px;"
              placeholder="please choose">
            <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
            <span style="float: left">{{ item.label }}</span>
            <span style="float: right; margin-right: 30px; color: #8492a6; font-size: 13px">{{ item.value }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      </el-col>
      <el-col :span = "7">
      <el-form-item label="Sold To:" label-width="125px">
            <el-select v-model="formInline.soldTos" multiple collapse-tags
              style="margin-left: 0px;"
              placeholder="please choose">
            <el-option
            v-for="item in soldToArr"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
        <!-- <el-form-item label="Brand:" label-width="125px">
          <el-select v-model="formInline.brands"  collapse-tags
                placeholder="please choose">
              <el-option
              v-for="item in this.brandList"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item> -->
      </el-col>
      <el-col :span = "8">
        <el-form-item label="Item Description:" label-width="200px">
          <el-input v-model="formInline.itemDesc" placeholder="Item Description" clearable></el-input>
        </el-form-item>
      </el-col>
      </el-row>
      <el-row>
        <el-col :span = "6">
        <el-form-item label="Supplier:" label-width="115px">
          <el-input v-model="formInline.supplier" placeholder="Supplier" clearable></el-input>
        </el-form-item>
        </el-col>
        <el-col :span = "7">
     <el-form-item label="Brand:" label-width="125px">
       <el-select v-model="formInline.brands" multiple collapse-tags
             style="margin-left: 0px;"
             placeholder="please choose">
           <el-option
           v-for="item in this.brandList"
           :key="item"
           :label="item"
           :value="item">
         </el-option>
       </el-select>
     </el-form-item>
      </el-col>
<el-col :span = "8">
  <el-form-item label="Delivery Address:" label-width="200px">
    <el-select v-model="formInline.deliveryAddr" multiple collapse-tags
          style="margin-left: 0px;"   filterable
          placeholder="please choose">
        <el-option
        v-for="item in this.deliveryAddrList"
        :key="item"
        :label="item"
        :value="item">
        <!-- <span style="float: left">{{ item.description }}</span>
        <span style="float: right; margin-right: 30px; color: #8492a6; font-size: 13px">{{ item.code }}</span> -->
      </el-option>
    </el-select>
  </el-form-item>

      </el-col>
      <!-- <el-col :span = "1">
        <el-form-item>
        <el-tag>Net CBM:{{ this.updateTime }}  Gross CBM:{{ this.updateTime }}</el-tag>
        </el-form-item>
         </el-col> -->
      </el-row>
      <el-row>
        <el-col :span = "6">
          <el-form-item label="Item:" label-width="115px">
            <el-input v-model="formInline.item" placeholder="Item" clearable></el-input>
            </el-form-item>
              </el-col>
              <el-col :span = "7">
              <el-form-item label="Incoterm City:" label-width="125px">
                <el-select v-model="formInline.incotermCity"  collapse-tags clearable
                      style="margin-left: 0px;"
                      placeholder="please choose">
                    <el-option
                    v-for="item in this.incotermCityArr"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
               </el-col>
              <el-col :span = "8">
<el-form-item style="margin-left: 115px;">
        <el-button type="primary" @click="onSubmit">Search</el-button>
        <el-button type="primary" @click="rfqDialogOpen">RFQ</el-button>
        <el-button type="primary" @click="addDialogOpen">Add</el-button>
      </el-form-item>
      </el-col>
      </el-row>
      </div>
      <div v-else>
<el-row>
<el-col :span = "6">
      <el-form-item label="Status:" label-width="115px">
            <el-select v-model="formInline.status" multiple collapse-tags
              style="margin-left: 0px;"
              placeholder="please choose">
            <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
            <span style="float: left">{{ item.label }}</span>
            <span style="float: right; margin-right: 30px; color: #8492a6; font-size: 13px">{{ item.value }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      </el-col>
      <el-col :span = "6">
      <el-form-item label="Item:" label-width="115px">
        <el-input v-model="formInline.item" placeholder="Item" clearable></el-input>
      </el-form-item>
      </el-col>
      <el-col :span = "8">
        <el-form-item label="Item Description:" label-width="200px">
          <el-input v-model="formInline.itemDesc" placeholder="Item Description" clearable></el-input>
        </el-form-item>
      </el-col>
      </el-row>
      <el-row>
        <el-col :span = "6">
     <el-form-item label="Brand:" label-width="115px">
       <el-select v-model="formInline.brands" multiple collapse-tags
             style="margin-left: 0px;"
             placeholder="please choose">
           <el-option
           v-for="item in this.brandList"
           :key="item"
           :label="item"
           :value="item">
         </el-option>
       </el-select>
     </el-form-item>
      </el-col>
      <el-row>
      <el-col :span = "6">
            <el-form-item label="Sold To:" label-width="115px">
                  <el-select v-model="formInline.soldTos" multiple collapse-tags
                    style="margin-left: 0px;"
                    placeholder="please choose">
                  <el-option
                  v-for="item in soldToArr"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            </el-col>
            <el-col :span = "6">
            <el-form-item label="Item:" label-width="115px">
              <el-input v-model="formInline.item" placeholder="Item" clearable></el-input>
            </el-form-item>
            </el-col>
            </el-row>
<el-col :span = "6">
      <el-form-item style="margin-left: 111px;">
        <el-button type="primary" @click="onSubmit">Search</el-button>
        <el-button type="primary" @click="rfqDialogOpen">RFQ</el-button>
      </el-form-item>
      </el-col>
      </el-row>
      </div>
      <el-tag style="margin-bottom: 5px;"><span style="font-size:10px;">Net CBM:</span>{{ this.netCbm }} ,&nbsp; Gross CBM:{{ this.grossCbm }}</el-tag>
    </el-form>
    <el-dialog title="Add To" :visible.sync="addDialogVisible"  width="35%">
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="Cargo ID:">
          <el-select v-model="rfqAddform.add2File" placeholder="Please Choose">
          <el-option
                v-for="item in this.fglFileNameSelection"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
          </el-select>
          </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">Cancel</el-button>
        <el-button type="primary"  :disabled="btnAddChangeEnable" @click="Add2RfgFile">Ok</el-button>
      </div>
    </el-dialog>
    <el-dialog title="RFQ Fowarder" class="dialogTitle"
      width="70%" :visible.sync="dialogFormVisible">
      <el-form :model="rfqOpenform" width="100%" label-width="250px"  ref="rfqOpenform" size="mini" font-size="7px">
      <!-- <el-form-item style="margin-left: 10px;" label="RFQ File Descr." label-width="150px">
          <el-input v-model="fileDescr" style="width: 300px"></el-input>
        </el-form-item> -->

      <el-button style="margin-bottom: 10px;" type="primary" @click="addRfqRow">Add new</el-button>
        <el-table :data="this.multipleSelection" border stripe style="width: 100%" size="mini" :span-method="objectSpanMethod">
              <el-table-column type="index" label="#"></el-table-column>
              <el-table-column property="status" label="Status" width="95">
                <template slot-scope="scope">
                <el-select v-model="scope.row.status"  collapse-tags clearable v-if="scope.row.flag==='add' || scope.row.flag==='edit'"
                      style="margin-left: 0px;"   size="mini"
                      placeholder="please choose">
                    <el-option
                    v-for="item in statusArr"
                    :key="item.value"
                    :label="item.value"
                    :value="item.value">
                    <span style="float: left">{{ item.label }}</span>
                    <span style="float: right; margin-right: 30px; color: #8492a6; font-size: 13px">{{ item.value }}</span>
                  </el-option>
                </el-select>
                  <div  v-if="scope.row.flag==='view'">{{scope.row.status}}</div>
                  </template>
              </el-table-column>
              <el-table-column property="schSeq" label="Sch. Seq" width="100"  :show-overflow-tooltip="true">
                <template slot-scope="scope">
                <el-select v-model="scope.row.schSeq" v-if="scope.row.flag==='add'" default-first-option size="mini">
                  <el-option
                    v-for="item in schSeqArr"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                  </el-select>
                <div  v-if="scope.row.flag==='view'">{{scope.row.schSeq}}</div>
                </template>
              </el-table-column>
               <el-table-column property="schDate" label="Sch Date" width="100">
                 <template slot-scope="scope">
                         <el-date-picker v-if="scope.row.flag==='add' || scope.row.flag==='edit'"
                           v-model="scope.row.schDate"   size="mini"  value-format="yyyy-MM-dd"
                           type="date"
                           placeholder="sch Date">
                         </el-date-picker>
                <div v-if="scope.row.flag==='view'" value-format="yyyy-MM-dd"> {{dateFormat1(scope.row.schDate) }}</div>
                </template>
              </el-table-column>
              <el-table-column property="schQ" label="Sch. Q" width="100"  :show-overflow-tooltip="true">
                <template slot-scope="scope">
                <el-input  v-if="scope.row.flag==='add'" v-model="scope.row.schQ" size="mini" :data-id="scope.row.idx" @blur="checkSchQty($event)" maxlength=10></el-input>
                <div  v-if="scope.row.flag==='view'">{{scope.row.schQ}}</div>
                </template>
              </el-table-column>
              <!-- <el-table-column property="schDate2" label="sch Date2" width="100">
                 <template slot-scope="scope">
                         <el-date-picker v-if="scope.row.flag==='add' || scope.row.flag==='edit'"
                           v-model="scope.row.schDate2"   size="mini"  value-format="yyyy-MM-dd"
                           type="date"
                           placeholder="sch Date2">
                         </el-date-picker>
                <div v-if="scope.row.flag==='view'" value-format="yyyy-MM-dd"> {{dateFormat1(scope.row.schDate2) }}</div>
                </template>
              </el-table-column>
              <el-table-column property="schDate3" label="sch Date3" width="100">
                 <template slot-scope="scope">
                         <el-date-picker v-if="scope.row.flag==='add' || scope.row.flag==='edit'"
                           v-model="scope.row.schDate3"   size="mini"  value-format="yyyy-MM-dd"
                           type="date"
                           placeholder="sch Date3">
                         </el-date-picker>
                <div v-if="scope.row.flag==='view'" value-format="yyyy-MM-dd"> {{dateFormat1(scope.row.schDate3) }}</div>
                </template>
              </el-table-column>
                <el-table-column property="schDate4" label="sch Date4" width="100">
                 <template slot-scope="scope">
                         <el-date-picker v-if="scope.row.flag==='add' || scope.row.flag==='edit'"
                           v-model="scope.row.schDate4"   size="mini"  value-format="yyyy-MM-dd"
                           type="date"
                           placeholder="sch Date4">
                         </el-date-picker>
                <div v-if="scope.row.flag==='view'" value-format="yyyy-MM-dd"> {{dateFormat1(scope.row.schDate4) }}</div>
                </template>
              </el-table-column> -->
              <el-table-column property="supplier" label="Supplier" width="100" sortable>
                <template slot-scope="scope">
                <el-input  v-if="scope.row.flag==='add'" v-model="scope.row.supplier" size="mini"></el-input>
                <div  v-if="scope.row.flag==='view'">{{scope.row.supplier}}</div>
                </template>
              </el-table-column>
              <!-- <el-table-column property="brand" label="Brand" width="100"  :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.brand" collapse-tags size="mini"
                        style="margin-left: 0px;"  filterable  v-if="scope.row.flag==='add' || scope.row.flag==='edit'"
                        placeholder="please choose">
                      <el-option
                      v-for="item in dialogBrands"
                      :key="item"
                      :label="item"
                      :value="item">
                    </el-option>
                  </el-select>
                <div  v-if="scope.row.flag==='view'">{{scope.row.brand}}</div>
                </template>
              </el-table-column> -->
              <el-table-column property="intnlRef" label="Internal reference" width="170" sortable :show-overflow-tooltip="true">
                <template slot-scope="scope">
                <el-input  v-if="scope.row.flag==='add'" v-model="scope.row.intnlRef" size="mini" maxlength=50></el-input>
                <div  v-if="scope.row.flag==='view'">{{scope.row.intnlRef}}</div>
                </template>
              </el-table-column>

              <el-table-column property="item" label="Item" width="110" sortable :show-overflow-tooltip="true">
                <template slot-scope="scope">
                <el-input  v-if="scope.row.flag==='add'" v-model="scope.row.item" size="mini" :data-id="scope.row.idx" maxlength=50 @blur="checkItemNumber($event)"></el-input>
                <div  v-if="scope.row.flag==='view'">{{scope.row.item}}</div>
                </template>
              </el-table-column>

              <el-table-column property="itemDesc" label="Item Description" width="159" sortable :show-overflow-tooltip="true">
                <template slot-scope="scope">
                <!-- <el-input  v-if="scope.row.flag==='add'" v-model="scope.row.itemDesc" size="mini" maxlength=250></el-input>
                <div  v-if="scope.row.flag==='view'">{{scope.row.itemDesc}}</div> -->
                <div>{{scope.row.itemDesc}}</div>
                </template>
              </el-table-column>

              <el-table-column property="brand" label="Brand" width="100"  :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.brand"  collapse-tags  size="mini"
                        style="margin-left: 0px;"  v-if="scope.row.flag==='add' || scope.row.flag==='edit'"
                        placeholder="please choose">
                      <el-option
                      v-for="item in brandList"
                      :key="item"
                      :label="item"
                      :value="item">
                    </el-option>
                  </el-select>
                <!-- <el-input  v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.soldTo" size="mini" maxlength=50></el-input> -->
                <div  v-if="scope.row.flag==='view'">{{scope.row.brand}}</div>
                </template>
              </el-table-column>

              <!-- <el-table-column property="schQ2" label="Sch. Q2" width="100"  :show-overflow-tooltip="true">
                <template slot-scope="scope">
                <el-input  v-if="scope.row.flag==='add'" v-model="scope.row.schQ2" size="mini" @blur="checkInteger($event)" maxlength=10></el-input>
                <div  v-if="scope.row.flag==='view'">{{scope.row.schQ2}}</div>
                </template>
              </el-table-column>
              <el-table-column property="schQ3" label="Sch. Q3" width="100"  :show-overflow-tooltip="true">
                <template slot-scope="scope">
                <el-input  v-if="scope.row.flag==='add'" v-model="scope.row.schQ3" size="mini" @blur="checkInteger($event)" maxlength=10></el-input>
                <div  v-if="scope.row.flag==='view'">{{scope.row.schQ3}}</div>
                </template>
              </el-table-column>
              <el-table-column property="schQ4" label="Sch. Q4" width="100"  :show-overflow-tooltip="true">
                <template slot-scope="scope">
                <el-input  v-if="scope.row.flag==='add'" v-model="scope.row.schQ4" size="mini" @blur="checkInteger($event)" maxlength=10></el-input>
                <div  v-if="scope.row.flag==='view'">{{scope.row.schQ4}}</div>
                </template>
              </el-table-column> -->
              <el-table-column property="length" label="Length" width="90" sortable>
                <template slot-scope="scope">
                <!-- <el-input  v-if="scope.row.flag==='add'" v-model="scope.row.length" size="mini" @blur="checkNum($event)" maxlength=10></el-input>
                <div  v-if="scope.row.flag==='view'">{{scope.row.length}}</div> -->
                <div>{{scope.row.length}}</div>
                </template>
              </el-table-column>

              <el-table-column property="width" label="Width" width="80" sortable>
                <template slot-scope="scope">
                <!-- <el-input  v-if="scope.row.flag==='add'" v-model="scope.row.width" size="mini" @blur="checkNum($event)" maxlength=10></el-input>
                <div  v-if="scope.row.flag==='view'">{{scope.row.width}}</div> -->
                <div>{{scope.row.width}}</div>
                </template>
              </el-table-column>

              <el-table-column property="height" label="Height" width="90" sortable>
                <template slot-scope="scope">
                <!-- <el-input  v-if="scope.row.flag==='add'" v-model="scope.row.height" size="mini" @blur="checkNum($event)" maxlength=10></el-input> -->
                <div>{{scope.row.height}}</div>
                <!-- <div  v-if="scope.row.flag==='view'">{{scope.row.height}}</div> -->
                </template>
              </el-table-column>

              <el-table-column property="carton" label="Carton" width="90" sortable :formatter="numFormat">
                <template slot-scope="scope">
                <el-input  v-if="scope.row.flag==='add'" v-model="scope.row.carton" size="mini" @blur="checkCartonNum($event)" maxlength=10></el-input>
                <!-- <div>{{scope.row.carton}}</div> -->
                </template>
              </el-table-column>

              <el-table-column property="nw" label="NW" width="90" sortable>
                <template slot-scope="scope">
                <el-input  v-if="scope.row.flag==='add'" v-model="scope.row.nw" size="mini" @blur="checkNwNum($event)" maxlength=10></el-input>
                <!-- <div>{{scope.row.nw}}</div> -->
                </template>
              </el-table-column>

              <el-table-column property="gw" label="GW" width="90" sortable>
                <template slot-scope="scope">
                <el-input  v-if="scope.row.flag==='add'" v-model="scope.row.gw" size="mini" @blur="checkNum($event)" maxlength=10></el-input>
                <!-- <div>{{scope.row.gw}}</div> -->
                </template>
              </el-table-column>

              <el-table-column property="volumn" label="Volume (CBM)" width="136" sortable>
                <template slot-scope="scope">
                <el-input  v-if="scope.row.flag==='add'" v-model="scope.row.volumn" size="mini" @blur="checkNumCBM($event)" maxlength=10></el-input>
                <!-- <div>{{scope.row.volumn}}</div> -->
                </template>
              </el-table-column>

              <el-table-column property="soldTo" label="Sold to" width="120">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.soldTo"  collapse-tags  size="mini"
                        style="margin-left: 0px;"  v-if="scope.row.flag==='add' || scope.row.flag==='edit'"
                        placeholder="please choose">
                      <el-option
                      v-for="item in soldToArr"
                      :key="item"
                      :label="item"
                      :value="item">
                    </el-option>
                  </el-select>
                <!-- <el-input  v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.soldTo" size="mini" maxlength=50></el-input> -->
                <div  v-if="scope.row.flag==='view'">{{scope.row.soldTo}}</div>
                </template>
              </el-table-column>
              <el-table-column property="deliveryAddr" label="Delivery address" width="160" sortable>
                <template slot-scope="scope">
                  <el-select v-model="scope.row.deliveryAddr"  collapse-tags  size="mini" @change="addToFinalDeliveryAddrList"
                        style="margin-left: 0px;"  v-if="scope.row.flag==='add' || scope.row.flag==='edit'"
                        placeholder="please choose">
                      <el-option
                      v-for="item in deliveryAddrList"
                      :key="item"
                      :label="item"
                      :value="item">
                    </el-option>
                  </el-select>
                <div  v-if="scope.row.flag==='view'">{{scope.row.deliveryAddr}}</div>
                </template>
              </el-table-column>

              <el-table-column property="incotermCity" label="Incoterm City" width="136" sortable>
                <template slot-scope="scope">
                  <el-select v-model="scope.row.incotermCity"  collapse-tags  size="mini" @change="addToFinalIncotermCityList"
                          style="margin-left: 0px;"  v-if="scope.row.flag==='add' || scope.row.flag==='edit'"
                          placeholder="please choose">
                        <el-option
                        v-for="item in incotermCityList"
                        :key="item"
                        :label="item"
                        :value="item">
                      </el-option>
                    </el-select>
                  <div  v-if="scope.row.flag==='view'">{{scope.row.incotermCity}}</div>
                  <!-- <div  v-if="scope.row.flag==='view'">{{this.incotermCityArr[0]}}</div>
                  <el-select v-model="scope.row.incotermCity"  collapse-tags  size="mini"
                        style="margin-left: 0px;"  v-if="scope.row.flag==='add' || scope.row.flag==='edit'"
                        placeholder="please choose">
                      <el-option
                      v-for="item in incotermCityArr"
                      :key="item"
                      :label="item"
                      :value="item">
                    </el-option>
                  </el-select> -->
                <!-- <div>{{scope.row.incotermCity}}</div> -->
                </template>
              </el-table-column>

              <el-table-column property="srf" label="SRF" width="136">
                <template slot-scope="scope">
                <el-input v-model="scope.row.srf" size="mini" maxlength=10></el-input>
                </template>
              </el-table-column>
              <el-table-column property="cargoReadyDate" label="Cargo Ready Date" width="136">
                <template slot-scope="scope">
                        <el-date-picker
                          v-model="scope.row.cargoReadyDate"   size="mini"
                          type="date"
                          placeholder="Cargo Ready Date">
                        </el-date-picker>
                        </template>
              </el-table-column>
              <el-table-column property="SRFAppDate" label="SRF Application Date" width="155">
                <template slot-scope="scope">
                        <el-date-picker
                          v-model="scope.row.SRFAppDate"   size="mini"
                          type="date"
                          placeholder="SRF Application Date">
                        </el-date-picker>
                        </template>
              </el-table-column>
              <el-table-column property="freightCost" label="Freight Cost" width="136">
                <template slot-scope="scope">
                <el-input v-model="scope.row.freightCost"  @blur="checkNum($event)" size="mini" maxlength=10></el-input>
                </template>
              </el-table-column>
              <el-table-column property="freightForwName" label="Freight forwarder" width="136">
                <template slot-scope="scope">
                <el-input v-model="scope.row.freightForwName" size="mini" maxlength=50></el-input>
                </template>
              </el-table-column>
              <el-table-column property="palletNum" label="Number of Pallets" width="136">
                <template slot-scope="scope">
                <el-input v-model="scope.row.palletNum" size="mini" @blur="checkInteger($event)" maxlength=50></el-input>
                </template>
              </el-table-column>
              <el-table-column property="cartonsNoPallet" label="Carton without Pallets" width="176">
                <template slot-scope="scope">
                <el-input v-model="scope.row.cartonsNoPallet" size="mini" @blur="checkInteger($event)" maxlength=50></el-input>
                </template>
              </el-table-column>
              <el-table-column property="currency" label="Currency" width="136">
                <template slot-scope="scope">
                <el-select v-model="scope.row.currency" placeholder="Please choose" size="mini">
                  <el-option
                    v-for="item in currencyArr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                  </el-select>
                  </template>
              </el-table-column>

               <el-table-column property="approval" label="Approval" width="136">
                 <template slot-scope="scope">
                  <el-switch
                    style="display: block"   size="mini"  @change="approvalChange"
                    v-model="scope.row.approval"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-text="Yes"
                    inactive-text="No">
                  </el-switch>
                  </template>
                </el-table-column>
                <el-table-column property="approvalDate" label="Approval Date" width="136">
                  <template slot-scope="scope">
                          <el-date-picker
                            v-model="scope.row.approvalDate"   size="mini"
                            type="date"   :disabled="isDisabled"
                            placeholder="Approval Date">
                          </el-date-picker>
                          </template>
                </el-table-column>
                <el-table-column property="shipOut" label="Ship Out" width="136">
                  <template slot-scope="scope">
                   <el-switch
                     style="display: block"   size="mini"
                     v-model="scope.row.shipOut"
                     active-color="#13ce66"
                     inactive-color="#ff4949"
                     active-text="Yes"
                     inactive-text="No">
                   </el-switch>
                   </template>
                 </el-table-column>
                <el-table-column property="packingListNbr" label="Packing List" width="136">
                  <template slot-scope="scope">
                  <el-select v-model="scope.row.packingListNbr" collapse-tags
                        style="margin-left: 0px;" filterable   size="mini"
                        placeholder="please choose">
                      <el-option
                      v-for="item in packingList"
                      :key="item"
                      :label="item"
                      :value="item">
                    </el-option>
                  </el-select>
                  </template>
                  </el-table-column>
                  <el-table-column property="finalDeliveryAddr" label="Final Delivery Addr" width="156">
                    <template slot-scope="scope">
                    <el-select v-model="scope.row.finalDeliveryAddr" placeholder="Please choose" size="mini" allow-create filterable>
                      <el-option
                        v-for="item in selectedDeliveryAddress"
                        :key="item"
                        :label="item"
                        :value="item">
                      </el-option>
                      </el-select>
                      </template>
                  </el-table-column>
                  <el-table-column property="finalIncotermCity" label="Final Incoterm City" width="156">
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.finalIncotermCity" placeholder="Please choose" size="mini" allow-create filterable>
                        <el-option
                          v-for="item in selectedIncotermCity"
                          :key="item"
                          :label="item"
                          :value="item">
                        </el-option>
                        </el-select>
                      <!-- <div>{{scope.row.incotermCity}}</div> -->
                    <!-- <el-select v-model="scope.row.finalIncotermCity" placeholder="Please choose" size="mini">
                      <el-option
                        v-for="item in selectedIncotermCity"
                        :key="item"
                        :label="item"
                        :value="item">
                      </el-option>
                      </el-select> -->
                      </template>
                  </el-table-column>
                  <el-table-column property="etd" label="ETD" width="136">
                    <template slot-scope="scope">
                            <el-date-picker
                              v-model="scope.row.etd"   size="mini"
                              type="date"
                              placeholder="ETD">
                            </el-date-picker>
                            </template>
                  </el-table-column>
                  <el-table-column property="eta" label="ETA" width="136">
                    <template slot-scope="scope">
                            <el-date-picker
                              v-model="scope.row.eta"   size="mini"
                              type="date"
                              placeholder="ETA">
                            </el-date-picker>
                            </template>
                  </el-table-column>
                  <el-table-column property="comment" label="Comment" width="176">
                    <template slot-scope="scope">
                    <el-input v-model="scope.row.comment" size="mini" maxlength=50></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="operation"  width="136">
                    <template slot-scope="props">
                      <el-button type="info" plain size="mini" @click="delRfqRow(props.row.idx)">Delete</el-button>
                      </template>
                  </el-table-column>
            </el-table>
            </el-form>
            <el-tag style="margin-top: 5px;"><span style="font-size:10px;">Net CBM:</span>{{ this.netCbm }} ,&nbsp; Gross CBM:{{ this.grossCbm }}</el-tag>
            <div slot="footer" class="dialog-footer">
              <el-button  @click="dialogFormVisible = false">Cancel</el-button>
              <el-button  type="primary" :disabled="btnChangeEnable" @click="rfqDialogSave('projectOpenform')">Save</el-button>
            </div>
    </el-dialog>
      <!-- Schedule 列表区域 -->
      <el-table :data="readygoodsList" border stripe style="width: 100%"  @selection-change="handleSelectionChange">
        <el-table-column type="index" label="#" fixed></el-table-column>
        <el-table-column  fixed
              prop="selection"
              type="selection"
              width="55">
            </el-table-column>
            <el-table-column  fixed
              prop="status"     sortable
              label="Status" :show-overflow-tooltip="true"
              width="85">
            </el-table-column>
            <el-table-column  fixed
              prop="deliveryAddr"
              label="Delivery address"     sortable
              width="160">
            </el-table-column>
            <!--IP user-->
            <el-table-column
              prop="schSeq"
              label="Sch. Seq"  fixed
              width="100">
            </el-table-column>
            <el-table-column  fixed
              prop="schDate"
              label="Sch Date"       sortable
              width="110" :formatter="dateFormat">
            </el-table-column>
            <el-table-column  fixed
              prop="schQ"
              label="Sch. Q" :show-overflow-tooltip="true"
              width="100">
            </el-table-column>
            <!-- <el-table-column
              prop="schDate2"
              label="Sch Date2"       sortable
              width="110" :formatter="dateFormat">
            </el-table-column>
            <el-table-column
              prop="schDate3"
              label="Sch Date3"       sortable
              width="110" :formatter="dateFormat">
            </el-table-column>
            <el-table-column
              prop="schDate4"
              label="Sch Date4"       sortable
              width="110" :formatter="dateFormat">
            </el-table-column> -->
            <el-table-column  fixed
              prop="supplier"
              label="Supplier"     sortable
              width="100">
            </el-table-column>
            <el-table-column  fixed
              prop="brand"
              label="Brand"     sortable
              width="79">
            </el-table-column>

            <el-table-column
              prop="intnlRef"     sortable
              label="Internal reference" :show-overflow-tooltip="true"
              width="170">
            </el-table-column>

            <el-table-column
              prop="item"     sortable
              label="Item" :show-overflow-tooltip="true"
              width="90">
            </el-table-column>

            <el-table-column
              prop="itemDesc"
              label="Item Description" :show-overflow-tooltip="true"
              width="129">
            </el-table-column>
            <!-- <el-table-column
              prop="schQ2"
              label="Sch. Q2" :show-overflow-tooltip="true"
              width="100">
            </el-table-column>

            <el-table-column
              prop="schQ3"
              label="Sch. Q3" :show-overflow-tooltip="true"
              width="100">
            </el-table-column>

            <el-table-column
              prop="schQ4"
              label="Sch. Q4" :show-overflow-tooltip="true"
              width="100">
            </el-table-column> -->

            <el-table-column
              prop="length"
              label="Length"     sortable
              width="90">
            </el-table-column>

            <el-table-column
              prop="width"
              label="Width"     sortable
              width="80">
            </el-table-column>

            <el-table-column
              prop="height"
              label="Height"     sortable
              width="90">
            </el-table-column>

            <el-table-column
              prop="carton"     :formatter="numFormat"
              label="Carton"     sortable
              width="90">
            </el-table-column>

            <el-table-column
              prop="nw"
              label="NW"     sortable
              width="80">
            </el-table-column>

            <el-table-column
              prop="gw"
              label="GW"     sortable
              width="70">
            </el-table-column>

            <el-table-column
              prop="volumn"
              label="Volume (CBM)"     sortable
              width="130">
            </el-table-column>

            <el-table-column
              prop="soldTo"
              label="Sold to"     sortable
              width="100">
            </el-table-column>

            <!-- <el-table-column
              prop="deliveryAddr"
              label="Delivery address"     sortable
              width="160">
            </el-table-column> -->

            <el-table-column
              prop="incotermCity"
              label="Incoterm City"     sortable
              width="136">
            </el-table-column>

          </el-table>

          <!-- 分页区域     :formatter="numFormat"-->
           <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="formInline.page"
                :page-sizes="[10, 20, 30, 50, 100, total]"
                :page-size="formInline.rows"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
              </el-pagination>
  </el-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      formInline: {
        status: '',
        supplier: '',
        brands: [],
        item: '',
        itemDesc: '',
        deliveryAddr: [],
        incotermCity: [],
        soldTos: [],
        token: '',
        isRfqStr: true,
        page: 1,
        rows: 100
      },
      btnChangeEnable: false,
      btnAddChangeEnable: false,
      deliveryAddrList: '',
      rfqOpenform: {
      },
      isDisabled: false,
      rfqAddform: {
        add2File: ''
      },
      tableidx: 0,
      operation: '',
      dialogFormVisible: false,
      addDialogVisible: false,
      readygoodsList: [],
      brandList: [],
      packingList: [],
      userName: '',
      updateTime: '',
      total: 0,
      brandParam: {
        userName: '',
        userType: ''
      },
      currencyArr: [{
        value: 'USD',
        label: 'USD'
      }, {
        value: 'EUR',
        label: 'EUR'
      }, {
        value: 'RMB',
        label: 'RMB'
      }],
      currency: 'USD',
      statusArr: [{
        value: 'DEV',
        label: 'Development',
        description: 'Development'
      }, {
        value: 'HLD',
        label: 'On Hold',
        description: 'On Hold'
      }, {
        value: 'LHK',
        label: 'Loading Hong Kong',
        description: 'Loading Hong Kong'
      }, {
        value: 'LSH',
        label: 'Loading Shanghai',
        description: 'Loading Shanghai'
      }, {
        value: 'LXI',
        label: 'Loading Xiamen',
        description: 'Loading Xiamen'
      }, {
        value: 'LYA',
        label: 'Loading Yantian',
        description: 'Loading Yantian'
      }, {
        value: 'NEW',
        label: 'New Order',
        description: 'New Order'
      }, {
        value: 'OKC',
        label: 'Confirmed to Close on arrival',
        description: 'Confirmed to Close on arrival'
      }, {
        value: 'OLO',
        label: 'On Line QC Pass',
        description: 'On Line QC Pass'
      }, {
        value: 'ONG',
        label: 'On Going Production',
        description: 'On Going Production'
      }, {
        value: 'PND',
        label: 'Pending for Approval',
        description: 'Pending for Approval'
      }, {
        value: 'PNO',
        label: 'Produce with Next Order',
        description: 'Produce with Next Order'
      }, {
        value: 'REJ',
        label: 'Reject',
        description: 'Reject'
      }, {
        value: 'RHK',
        label: 'Ready Hong Kong',
        description: 'Ready Hong Kong'
      }, {
        value: 'RSH',
        label: ' Ready Shanghai',
        description: ' Ready Shanghai'
      }, {
        value: 'RTC',
        label: 'Request to Close',
        description: 'Request to Close'
      }, {
        value: 'RXI',
        label: 'Ready Xiamen',
        description: 'Ready Xiamen'
      }, {
        value: 'RYA',
        label: 'Ready Yantian',
        description: 'Ready Yantian'
      }, {
        value: 'SFR',
        label: 'Shipment ready from France',
        description: 'Shipment ready from France'
      }, {
        value: 'SME',
        label: 'Shipment ready from Mexico',
        description: 'Shipment ready from Mexico'
      }, {
        value: 'TLB',
        label: 'Ready for Transfer to LB',
        description: 'Ready for Transfer to LB'
      }, {
        value: 'TYF',
        label: 'Ready for Transfer to Yufan',
        description: 'Ready for Transfer to Yufan'
      }, {
        value: 'WFC',
        label: 'Waiting for confirmation',
        description: 'Waiting for confirmation'
      }
      ],
      options: [{
        value: 'DEV',
        label: 'Development',
        description: 'Development'
      }, {
        value: 'HLD',
        label: 'On Hold',
        description: 'On Hold'
      }, {
        value: 'LHK',
        label: 'Loading Hong Kong',
        description: 'Loading Hong Kong'
      }, {
        value: 'LSH',
        label: 'Loading Shanghai',
        description: 'Loading Shanghai'
      }, {
        value: 'LXI',
        label: 'Loading Xiamen',
        description: 'Loading Xiamen'
      }, {
        value: 'LYA',
        label: 'Loading Yantian',
        description: 'Loading Yantian'
      }, {
        value: 'NEW',
        label: 'New Order',
        description: 'New Order'
      }, {
        value: 'OKC',
        label: 'Confirmed to Close on arrival',
        description: 'Confirmed to Close on arrival'
      }, {
        value: 'OLO',
        label: 'On Line QC Pass',
        description: 'On Line QC Pass'
      }, {
        value: 'ONG',
        label: 'On Going Production',
        description: 'On Going Production'
      }, {
        value: 'PND',
        label: 'Pending for Approval',
        description: 'Pending for Approval'
      }, {
        value: 'PNO',
        label: 'Produce with Next Order',
        description: 'Produce with Next Order'
      }, {
        value: 'REJ',
        label: 'Reject',
        description: 'Reject'
      }, {
        value: 'RHK',
        label: 'Ready Hong Kong',
        description: 'Ready Hong Kong'
      }, {
        value: 'RSH',
        label: ' Ready Shanghai',
        description: ' Ready Shanghai'
      }, {
        value: 'RTC',
        label: 'Request to Close',
        description: 'Request to Close'
      }, {
        value: 'RXI',
        label: 'Ready Xiamen',
        description: 'Ready Xiamen'
      }, {
        value: 'RYA',
        label: 'Ready Yantian',
        description: 'Ready Yantian'
      }, {
        value: 'SFR',
        label: 'Shipment ready from France',
        description: 'Shipment ready from France'
      }, {
        value: 'SME',
        label: 'Shipment ready from Mexico',
        description: 'Shipment ready from Mexico'
      }, {
        value: 'TLB',
        label: 'Ready for Transfer to LB',
        description: 'Ready for Transfer to LB'
      }, {
        value: 'TYF',
        label: 'Ready for Transfer to Yufan',
        description: 'Ready for Transfer to Yufan'
      }, {
        value: 'WFC',
        label: 'Waiting for confirmation',
        description: 'Waiting for confirmation'
      }
      ],
      customerBrands: [{
        customerCode: 'BUBBLE',
        brandCode: ['BUBBLE']
      }, {
        customerCode: 'CSP',
        brandCode: ['CSP']
      }, {
        customerCode: 'DERA',
        brandCode: ['PION']
      }, {
        customerCode: 'EC',
        brandCode: ['EC']
      }, {
        customerCode: 'ELLA',
        brandCode: ['ELLA']
      }, {
        customerCode: 'HBG',
        brandCode: ['B&M', 'BJ', 'BM', 'CANDIES', 'Jones', 'JOR', 'MJ', 'PMF', 'TAHARI']
      }, {
        customerCode: 'IP',
        brandCode: ['AF', 'AP', 'AS', 'BB', 'BEBE', 'DKNY', 'DUN', 'FC', 'FCUK', 'FER', 'GRAFF', 'GUESS', 'HOL', 'JPF', 'MCM', 'MULTI', 'ODLR', 'TJMAXX', 'UNG']
      }, {
        customerCode: 'IPIT',
        brandCode: ['FER', 'UNG']
      }, {
        customerCode: 'JEN',
        brandCode: ['JEN']
      }, {
        customerCode: 'NPS',
        brandCode: ['BRANDFREE']
      }, {
        customerCode: 'OMC',
        brandCode: ['OMC']
      }, {
        customerCode: 'OWILD',
        brandCode: ['OWILD']
      }, {
        customerCode: 'SIK',
        brandCode: ['SIK']
      }, {
        customerCode: 'SDPP',
        brandCode: ['GUESS', 'MCM']
      }, {
        customerCode: 'TSM',
        brandCode: ['TSM BRANDS']
      }],
      soldToArr: ['IP', 'OMC', 'CSP', 'HORIZONB', 'OWILD', 'SDPP', 'JEN', 'LASH', 'TSM', 'OSEE', 'BUBBLE', 'GOTHA', 'TSMT', 'SAP', 'DIJO', 'TBY', 'EXERTIER', 'NPS', 'HERON', 'J3P', 'PPI', 'ESF', 'IPIT'],
      schSeqArr: ['Sch. 1', 'Sch. 2', 'Sch. 3', 'Sch. 4'],
      incotermCityArr: ['SHANGHAI', 'HUZHOU', 'YANTIAN', 'SHENZHEN', 'NINGBO', 'XIAMEN', 'DONGGUAN', 'HANGZHOU', 'SHAOXIN', 'GUANGZHOU'],
      netCbm: 0,
      grossCbm: 0,
      totalCarton: 0,
      totalNw: 0,
      totalGw: 0,
      totalSchQ: 0,
      multipleSelection: [],
      rgl: {
        idx: -1,
        id: -1,
        status: '',
        schDate: null,
        schQ: '',
        schSeq: '',
        supplier: '',
        brand: '',
        intnlRef: '',
        item: '',
        itemDesc: '',
        length: '',
        width: '',
        height: '',
        carton: '',
        nw: '',
        gw: '',
        volumn: '',
        pckCap: '',
        yp_net: '',
        yp_gross: '',
        soldTo: '',
        deliveryAddr: '',
        incotermCity: '',
        orderNo: '',
        line: '',
        srf: '',
        cargoReadyDate: null,
        SRFAppDate: null,
        freightCost: '',
        freightForwName: '',
        palletNum: '',
        currency: '',
        approval: true,
        approvalDate: new Date(),
        shipOut: false,
        packingListNbr: '',
        finalDeliveryAddr: '',
        finalIncotermCity: '',
        customerCd: '',
        etd: null,
        eta: null,
        flag: 'view'
      },
      // rfqTbl: {
      //   rglFileName: '',
      // },
      fglFileNameSelection: [],
      add2File: '',
      index: 0,
      selected: false,
      cbmNoPrecise: 0,
      selectedIncotermCity: [],
      selectedDeliveryAddress: [],
      dialogBrands: [],
      subcoll: false,
      selectedBrands: [],
      currCustomerCode: '',
      customerCodeinRglFile: ''
    }
  },
  created () {
    this.userName = window.sessionStorage.getItem('username')
    this.formInline.token = window.sessionStorage.getItem('token')
    this.getRfqForwarderList()
    this.brandParam.userName = this.userName
    this.brandParam.userType = window.sessionStorage.getItem('userType')
    // this.formInline.status = ['RSH', 'RYA']
    this.getBrands()
    this.btnChangeEnable = false
    this.getDeliveryAddrList()
    this.getIncotermCityList()
  },
  methods: {
    async getRglFileNames () {
      const { data: res } = await this.$http.get('/show/getRglFileNames')
      this.fglFileNameSelection = await res.rglFileNames
    },
    async getCustomerCodebyRglFileName (rglFileName) {
      const { data: res } = await this.$http.get('/show/getCustomerCodeByRglFileName', { params: { rglFileName: rglFileName } })
      this.customerCodeinRglFile = await res.customerCode
    },
    approvalChange (value) {
      if (value) {
        for (var i = 0; i < this.multipleSelection.length; i++) {
          this.multipleSelection[i].approvalDate = new Date()
          this.isDisabled = false
        }
      } else {
        for (i = 0; i < this.multipleSelection.length; i++) {
          this.multipleSelection[i].approvalDate = null
          this.isDisabled = true
        }
      }
    },
    async chooseRfqFile () {
      this.btnAddChangeEnable = true
      const { data: res } = await this.$http.post('/show/rfqAddSave', { params: this.multipleSelection })
      var result = await res.result
      if (result !== 'none') {
        this.$alert('Line ' + result + ' is added to Rgl file already. Please check.', 'Warning', {
          confirmButtonText: 'Ok',
          callback: action => {
            this.$message({
              type: 'info',
              message: 'action'
            })
          }
        })
        this.btnAddChangeEnable = false
      } else {
        this.btnAddChangeEnable = true
        // this.rfqTbl.rglFileName = result
        // console.log('result === ' + result)
        // await this.$http.post('/show/rfqTblSave', { params: this.rfqTbl })
        this.dialogFormVisible = false
        this.index = 0
        this.$message.success('Save successfully!')
        await this.getRfqForwarderList()
      }
    },
    indexMethod (index) {
      this.tableidx = index
    },
    checkSchQty (e) {
      if (e.target.value === null || e.target.value === '') {
        return
      }
      if (!(/(^[1-9]\d*$)/.test(e.target.value))) {
      // if (isNaN(e.target.value)) {
        this.$alert('Please input NUMBER', 'Warning', {
          confirmButtonText: 'Ok',
          callback: action => {
            // this.$message({
            //   type: 'info',
            //   message: 'aaa'
            // })
            e.target.focus()
          }
        })
      } else {
        var rowId = e.target.dataset.id
        for (var j = 0; j < this.multipleSelection.length; j++) {
          if (Number(rowId) === Number(this.multipleSelection[j].idx)) {
            if (this.multipleSelection[j].item !== '' && this.multipleSelection[j].item !== null) {
              if (this.multipleSelection[j].pckCap !== 0) {
                this.multipleSelection[j].carton = Math.ceil(e.target.value / this.multipleSelection[j].pckCap)
                this.multipleSelection[j].nw = Math.round(this.multipleSelection[j].yp_net * Math.ceil(e.target.value / this.multipleSelection[j].pckCap) * 10) / 10
                this.multipleSelection[j].gw = this.multipleSelection[j].yp_gross * Math.ceil(e.target.value / this.multipleSelection[j].pckCap)
                this.multipleSelection[j].volumn = Math.round((this.multipleSelection[j].height * this.multipleSelection[j].length * this.multipleSelection[j].width / 1000000) * (e.target.value / this.multipleSelection[j].pckCap) * 1000000) / 1000000
                this.totalSchQ += e.target.value
                this.totalNw += this.multipleSelection[j].nw
                this.totalGw += this.multipleSelection[j].gw
                this.totalCarton += this.multipleSelection[j].carton
              } else {
                this.multipleSelection[j].carton = 0
                this.multipleSelection[j].nw = 0
                this.multipleSelection[j].gw = 0
                this.multipleSelection[j].volumn = 0
              }
            }
            break
          }
        }
      }
    },
    checkInteger (e) {
      if (e.target.value === null || e.target.value === '') {
        return
      }
      if (!(/(^[1-9]\d*$)/.test(e.target.value))) {
      // if (isNaN(e.target.value)) {
        this.$alert('Please input NUMBER', 'Warning', {
          confirmButtonText: 'Ok',
          callback: action => {
            // this.$message({
            //   type: 'info',
            //   message: 'aaa'
            // })
            e.target.focus()
          }
        })
      }
    },
    checkNum (e) {
      // const that = this
      // console.log('event.target.value === ' + e.target.value)
      if (isNaN(e.target.value)) {
        this.$alert('Please input NUMBER or leave blank', 'Warning', {
          confirmButtonText: 'Ok',
          callback: action => {
            // this.$message({
            //   type: 'info',
            //   message: 'aaa'
            // })
            e.target.focus()
          }
        })
      }
    },
    async checkItemNumber (e) {
      // console.log(e)
      const { data: res } = await this.$http.get('/show/getItemInfobyItem', { params: { value: e.target.value.trim() } })
      var result = res.result
      var brand = result.brand
      // var customerCode = ''
      // for (var i = 0; i < this.customerBrands.length; i++) {
      //   var brandArr = this.customerBrands[i].brandCode
      //   if (brandArr.indexOf(brand) >= 0) {
      //     customerCode = this.customerBrands[i].customerCode
      //     break
      //   }
      // }
      var rowId = e.target.dataset.id
      for (var j = 0; j < this.multipleSelection.length; j++) {
        if (Number(rowId) === Number(this.multipleSelection[j].idx)) {
          this.multipleSelection[j].pckCap = result.pck_cap
          this.multipleSelection[j].itemDesc = result.item_desc
          this.multipleSelection[j].brand = brand
          this.multipleSelection[j].length = result.pck_length
          this.multipleSelection[j].width = result.pck_width
          this.multipleSelection[j].height = result.pck_height
          this.multipleSelection[j].yp_net = result.yp_net
          this.multipleSelection[j].yp_gross = result.yp_gross
          if (this.multipleSelection[j].schQ !== '') {
            this.multipleSelection[j].carton = Math.round(e.target.value / this.multipleSelection[j].pckCap)
            this.multipleSelection[j].nw = this.multipleSelection[j].yp_net * Math.round(e.target.value / this.multipleSelection[j].pckCap)
            this.multipleSelection[j].gw = this.multipleSelection[j].yp_gross * Math.round(e.target.value / this.multipleSelection[j].pckCap)
            this.multipleSelection[j].volumn = (this.multipleSelection[j].height * this.multipleSelection[j].length * this.multipleSelection[j].width / 1000000) * (e.target.value / this.multipleSelection[j].pckCap)
            this.totalSchQ += e.target.value
            this.totalNw += this.multipleSelection[j].nw
            this.totalGw += this.multipleSelection[j].gw
            this.totalCarton += this.multipleSelection[j].carton
          }
          break
        }
      }
      // alert('customerCode=== ' + customerCode + ',this.currCustomerCode ===' + this.currCustomerCode)
      // if (customerCode === '' || customerCode !== this.currCustomerCode) {
      //   this.$alert('The Item Number is incorrect. Please check.', 'Warning', {
      //     confirmButtonText: 'Ok',
      //     callback: action => {
      //       e.target.focus()
      //     }
      //   })
      // } else {
      //   var rowId = e.target.dataset.id
      //   for (var j = 0; j < this.multipleSelection.length; j++) {
      //     if (Number(rowId) === Number(this.multipleSelection[j].idx)) {
      //       this.multipleSelection[j].pckCap = result.pck_cap
      //       this.multipleSelection[j].itemDesc = result.item_desc
      //       this.multipleSelection[j].brand = brand
      //       this.multipleSelection[j].length = result.pck_length
      //       this.multipleSelection[j].width = result.pck_width
      //       this.multipleSelection[j].height = result.pck_height
      //       this.multipleSelection[j].yp_net = result.yp_net
      //       this.multipleSelection[j].yp_gross = result.yp_gross
      //       if (this.multipleSelection[j].schQ !== '') {
      //         this.multipleSelection[j].carton = Math.round(e.target.value / this.multipleSelection[j].pckCap)
      //         this.multipleSelection[j].nw = this.multipleSelection[j].yp_net * Math.round(e.target.value / this.multipleSelection[j].pckCap)
      //         this.multipleSelection[j].gw = this.multipleSelection[j].yp_gross * Math.round(e.target.value / this.multipleSelection[j].pckCap)
      //         this.multipleSelection[j].volumn = (this.multipleSelection[j].height * this.multipleSelection[j].length * this.multipleSelection[j].width / 1000000) * (e.target.value / this.multipleSelection[j].pckCap)
      //         this.totalSchQ += e.target.value
      //         this.totalNw += this.multipleSelection[j].nw
      //         this.totalGw += this.multipleSelection[j].gw
      //         this.totalCarton += this.multipleSelection[j].carton
      //       }
      //       break
      //     }
      //   }
      // }
    },
    /* checkCartonNum (e) {
      // const that = this
      // console.log('event.target.value === ' + e.target.value)
      if (isNaN(e.target.value)) {
        this.$alert('Please input NUMBER or leave bland', 'Warning', {
          confirmButtonText: 'Ok',
          callback: action => {
            // this.$message({
            //   type: 'info',
            //   message: 'aaa'
            // })
            e.target.focus()
          }
        })
      } else {
        this.netCbm = Math.round((this.cbmNoPrecise + Number(e.target.value)) * 100) / 100
        // console.log('this.cbmNoprecise === ' + this.cbmNoPrecise)
        // console.log('this.e.target.value === ' + e.target.value)
        // console.log('this.cbmNoPrecise + e.target.value === ' + (this.cbmNoPrecise + Number(e.target.value)))
        this.grossCbm = Math.round((this.cbmNoPrecise + Number(e.target.value)) * 1.18 * 100) / 100
        this.cbmNoPrecise = this.cbmNoPrecise + Number(e.target.value)
        // console.log('ennnnnnnnnnnnnnnnnnnnnnnnnnddddd222===cbm === ' + this.netCbm)
      }
    },
    checkCartonNum (e) {
      // const that = this
      // console.log('event.target.value === ' + e.target.value)
      if (isNaN(e.target.value)) {
        this.$alert('Please input NUMBER or leave bland', 'Warning', {
          confirmButtonText: 'Ok',
          callback: action => {
            // this.$message({
            //   type: 'info',
            //   message: 'aaa'
            // })
            e.target.focus()
          }
        })
      } else {
        this.netCbm = Math.round((this.cbmNoPrecise + Number(e.target.value)) * 100) / 100
        // console.log('this.cbmNoprecise === ' + this.cbmNoPrecise)
        // console.log('this.e.target.value === ' + e.target.value)
        // console.log('this.cbmNoPrecise + e.target.value === ' + (this.cbmNoPrecise + Number(e.target.value)))
        this.grossCbm = Math.round((this.cbmNoPrecise + Number(e.target.value)) * 1.18 * 100) / 100
        this.cbmNoPrecise = this.cbmNoPrecise + Number(e.target.value)
        // console.log('ennnnnnnnnnnnnnnnnnnnnnnnnnddddd222===cbm === ' + this.netCbm)
      }
    }, */
    checkNumCBM (e) {
      // const that = this
      // console.log('event.target.value === ' + e.target.value)
      if (isNaN(e.target.value)) {
        this.$alert('Please input NUMBER or leave bland', 'Warning', {
          confirmButtonText: 'Ok',
          callback: action => {
            // this.$message({
            //   type: 'info',
            //   message: 'aaa'
            // })
            e.target.focus()
          }
        })
      } else {
        this.netCbm = Math.round((this.cbmNoPrecise + Number(e.target.value)) * 100) / 100
        // console.log('this.cbmNoprecise === ' + this.cbmNoPrecise)
        // console.log('this.e.target.value === ' + e.target.value)
        // console.log('this.cbmNoPrecise + e.target.value === ' + (this.cbmNoPrecise + Number(e.target.value)))
        this.grossCbm = Math.round((this.cbmNoPrecise + Number(e.target.value)) * 1.18 * 100) / 100
        this.cbmNoPrecise = this.cbmNoPrecise + Number(e.target.value)
        // console.log('ennnnnnnnnnnnnnnnnnnnnnnnnnddddd222===cbm === ' + this.netCbm)
      }
    },
    /* checkNumCBM (e) {
      // const that = this
      // console.log('event.target.value === ' + e.target.value)
      if (isNaN(e.target.value)) {
        this.$alert('Please input NUMBER or leave bland', 'Warning', {
          confirmButtonText: 'Ok',
          callback: action => {
            // this.$message({
            //   type: 'info',
            //   message: 'aaa'
            // })
            e.target.focus()
          }
        })
      } else {
        this.netCbm = Math.round((this.cbmNoPrecise + Number(e.target.value)) * 100) / 100
        // console.log('this.cbmNoprecise === ' + this.cbmNoPrecise)
        // console.log('this.e.target.value === ' + e.target.value)
        // console.log('this.cbmNoPrecise + e.target.value === ' + (this.cbmNoPrecise + Number(e.target.value)))
        this.grossCbm = Math.round((this.cbmNoPrecise + Number(e.target.value)) * 1.18 * 100) / 100
        this.cbmNoPrecise = this.cbmNoPrecise + Number(e.target.value)
        // console.log('ennnnnnnnnnnnnnnnnnnnnnnnnnddddd222===cbm === ' + this.netCbm)
      }
    }, */
    async rfqDialogSave () {
      this.btnChangeEnable = true
      var saveInfo = { lines: this.multipleSelection, customerCode: this.currCustomerCode }
      const { data: res } = await this.$http.post('/show/rfqForwarderSave', { params: saveInfo })
      var result = await res.result
      if (result !== 'none') {
        this.$alert('Line ' + result + ' is added to Rgl file already. Please check.', 'Warning', {
          confirmButtonText: 'Ok',
          callback: action => {
            this.$message({
              type: 'info',
              message: 'action'
            })
          }
        })
        this.btnChangeEnable = false
      } else {
        this.btnChangeEnable = true
        // this.rfqTbl.rglFileName = result
        // console.log('result === ' + result)
        // await this.$http.post('/show/rfqTblSave', { params: this.rfqTbl })
        this.dialogFormVisible = false
        this.index = 0
        this.$message.success('Save successfully!')
        await this.getRfqForwarderList()
      }
    },
    async getDeliveryAddrList () {
      const { data: res } = await this.$http.get('/show/deliveryAddrList', { params: this.brandParam })
      this.deliveryAddrList = await res.deliveryAddr
    },
    async getIncotermCityList () {
      const { data: res } = await this.$http.get('/show/incotermCityList', { params: this.brandParam })
      this.incotermCityList = await res.incotermCityList
    },
    async getBrands () {
      const { data: res } = await this.$http.get('/common/brandList', { params: this.brandParam })
      this.brandList = await res.brands
    },
    async getPackingList () {
      const { data: res } = await this.$http.get('/show/getPackingList')
      this.packingList = await res.plnList
    },
    async addDialogOpen () {
      if (this.selected === false) {
        this.$alert('Please select the rows first!', 'Warning', {
          confirmButtonText: 'Ok',
          callback: action => {
            this.$message({
              type: 'info',
              message: 'action:'
            })
          }
        })
        return
      }

      this.getRglFileNames()
      this.addDialogVisible = true
      this.btnAddChangeEnable = false
    },
    async Add2RfgFile () {
      /* if (this.checkSelectedLines() === false) {
        return
      } */
      /* this.getCustomerCodebyRglFileName(this.rfqAddform.add2File)

      if (this.customerCodeinRglFile !== this.currCustomerCode) {
        if (this.currCustomerCode === 'IPIT' && this.customerCodeinRglFile === 'IP') {
        } else {
          this.$alert('The selected lines do not belong to the RGL File Customer!', 'Warning', {
            confirmButtonText: 'Ok',
            callback: action => {
              this.$message({
                type: 'info',
                message: 'action:'
              })
            }
          })
          return
        }
      } */
      var saveInfo = { lines: this.multipleSelection, addRglFileName: this.rfqAddform.add2File }
      const { data: res } = await this.$http.post('/show/rfqForwarderAdd', { params: saveInfo })
      var result = await res.result
      if (result !== 'none') {
        this.$alert('Line ' + result + ' is added to Rgl file already. Please check.', 'Warning', {
          confirmButtonText: 'Ok',
          callback: action => {
            this.$message({
              type: 'info',
              message: 'action'
            })
          }
        })
        this.btnAddChangeEnable = false
      } else {
        this.btnAddChangeEnable = true
        // this.rfqTbl.rglFileName = result
        // console.log('result === ' + result)
        // await this.$http.post('/show/rfqTblSave', { params: this.rfqTbl })
        this.addDialogVisible = false
        this.index = 0
        this.$message.success('Save successfully!')
        await this.getRfqForwarderList()
        this.selected = false
      }
    },
    async rfqDialogOpen () {
      if (this.selected === false) {
        this.$alert('Please select the rows first!', 'Warning', {
          confirmButtonText: 'Ok',
          callback: action => {
            this.$message({
              type: 'info',
              message: 'action:'
            })
          }
        })
        return
      }
      // if (this.selectedIncotermCity.length > 1) {
      //   this.$alert('The selected Incoterm City is not only one.', 'Warning', {
      //     confirmButtonText: 'OK',
      //     callback: null
      //   })
      //   return
      // }

      // if (this.checkSelectedLines() === false) {
      //   returngong
      // }
      // this.subcoll = true
      // for (var ii = 0; ii < this.customerBrands.length; ii++) {
      //   var brandCdArr = this.customerBrands[ii].brandCode
      //   for (var jj = 0; jj < brandCdArr.length; jj++) {
      //     console.log('brandCdArr === ' + brandCdArr[jj])
      //   }
      //   this.subcoll = true
      //   for (var j = 0; j < this.selectedBrands.length; j++) {
      //     if (brandCdArr.indexOf(this.selectedBrands[j]) === -1) {
      //       this.subcoll = false
      //       break
      //     }
      //   }
      //   if (this.subcoll === true) {
      //     this.dialogBrands = brandCdArr
      //     this.currCustomerCode = this.customerBrands[ii].customerCode
      //     break
      //   }
      // }
      // if (this.subcoll === false) {
      //   this.$alert('The selected lines are more than one customer!', 'Warning', {
      //     confirmButtonText: 'OK',
      //     callback: action => {
      //       this.$message({
      //         type: 'info',
      //         message: `action: ${action}`
      //       })
      //     }
      //   })
      //   return
      // }
      this.operation = 'view'
      this.getPackingList()
      this.dialogFormVisible = true
      this.btnChangeEnable = false
    },
    checkSelectedLines () {
      this.subcoll = true
      for (var ii = 0; ii < this.customerBrands.length; ii++) {
        var brandCdArr = this.customerBrands[ii].brandCode
        this.subcoll = true
        for (var j = 0; j < this.selectedBrands.length; j++) {
          if (brandCdArr.indexOf(this.selectedBrands[j]) === -1) {
            this.subcoll = false
            break
          }
        }
        if (this.subcoll === true) {
          this.dialogBrands = brandCdArr
          this.currCustomerCode = this.customerBrands[ii].customerCode
          break
        }
      }

      if (this.subcoll === false) {
        this.$alert('The selected lines are more than one customer!', 'Warning', {
          confirmButtonText: 'OK',
          callback: action => {
            this.$message({
              type: 'info',
              message: `action: ${action}`
            })
          }
        })
        return false
      }
      if (this.subcoll === true) {
        if (this.selectedBrands.length === 2 && this.selectedBrands.indexOf('FER') !== -1 && this.selectedBrands.indexOf('UNG') !== -1) {
          this.currCustomerCode = 'IPIT'
        } else if (this.selectedBrands.length === 1 && (this.selectedBrands.indexOf('FER') !== -1 || this.selectedBrands.indexOf('UNG') !== -1)) {
          this.currCustomerCode = 'IPIT'
        }
      }
      return true
    },
    addRfqRow () {
      this.operation = 'add'
      var length = this.multipleSelection.length
      if (length === 0) {
        return
      }
      if (this.multipleSelection[length - 1].status !== '' || this.multipleSelection[length - 1].schDate !== null || this.multipleSelection[length - 1].supplier !== '' || this.multipleSelection[length - 1].brand !== '' || this.multipleSelection[length - 1].intnlRef !== '' || this.multipleSelection[length - 1].item !== '' || this.multipleSelection[length - 1].itemDesc !== '' || this.multipleSelection[length - 1].schQ1 !== '' || this.multipleSelection[length - 1].schQ2 !== '' || this.multipleSelection[length - 1].schQ3 !== '' || this.multipleSelection[length - 1].schQ4 !== '' || this.multipleSelection[length - 1].length !== '' || this.multipleSelection[length - 1].width !== '' || this.multipleSelection[length - 1].height !== '' || this.multipleSelection[length - 1].carton !== '' || this.multipleSelection[length - 1].nw !== '' || this.multipleSelection[length - 1].gw !== '' || this.multipleSelection[length - 1].volumn !== '' || this.multipleSelection[length - 1].soldTo !== '' || this.multipleSelection[length - 1].deliveryAddr !== '' || this.multipleSelection[length - 1].incotermCity !== '' || this.multipleSelection[length - 1].freightCost !== '' || this.multipleSelection[length - 1].freightForwName !== '' || this.multipleSelection[length - 1].currency !== '' || this.multipleSelection[length - 1].etd !== null || this.multipleSelection[length - 1].packingListNbr !== '' || this.multipleSelection[length - 1].eta !== null) {
        this.rgl = { idx: this.index, id: -1, status: '', schDate: null, schQ: '', schSeq: 'Sch. 1', supplier: '', brand: '', intnlRef: '', item: '', itemDesc: '', length: '', width: '', height: '', carton: '', nw: '', gw: '', volumn: '', pckCap: '', yp_net: '', yp_gross: '', soldTo: '', deliveryAddr: '', incotermCity: '', srf: '', freightCost: '', freightForwName: '', palletNum: '', currency: '', approval: true, approvalDate: new Date(), shipOut: false, packingListNbr: '', finalDeliveryAddr: this.multipleSelection[0].deliveryAddr, finalIncotermCity: this.selectedIncotermCity[0], etd: null, eta: null, customerCd: this.currCustomerCode, flag: 'add' }
        this.multipleSelection.push(this.rgl)
        this.index++
      }
    },
    delRfqRow (value) {
      if (this.multipleSelection.length === 1) return
      for (var i = 0; i < this.multipleSelection.length; i++) {
        if (value === this.multipleSelection[i].idx) {
          this.netCbm = Math.round((this.cbmNoPrecise - Number(this.multipleSelection[i].volumn)) * 100) / 100
          this.grossCbm = Math.round((this.cbmNoPrecise - Number(this.multipleSelection[i].volumn)) * 1.18 * 100) / 100
          this.cbmNoPrecise = this.cbmNoPrecise - Number(this.multipleSelection[i].volumn)
          this.multipleSelection.splice(i, 1)
        }
      }
      // this.getRfqForwarderList()
    },
    addToFinalDeliveryAddrList (value) {
      // alert('listbox delivery value === ' + value)
      // alert('2222222222===' + event.target.value)
      if (value !== '' && value !== null) {
        if (this.selectedDeliveryAddress.indexOf(value) === -1) {
          this.selectedDeliveryAddress.push(value)
        }
      }
    },
    addToFinalIncotermCityList (value) {
      // alert('listbox delivery value === ' + value)
      // alert('2222222222===' + event.target.value)
      if (value !== '' && value !== null) {
        if (this.selectedIncotermCity.indexOf(value) === -1) {
          this.selectedIncotermCity.push(value)
        }
      }
    },
    handleSelectionChange (val) {
      this.cbmNoPrecise = 0
      this.netCbm = 0
      this.multipleSelection = []
      this.selectedBrands = []
      this.selectedIncotermCity = []
      this.selectedDeliveryAddress = []

      if (val !== '' && val !== null) {
        this.selected = true
        for (var i = 0; i < val.length; i++) {
          console.log('val[i].brand 111 === ' + val[i].brand)
          if (this.selectedBrands.indexOf(val[i].brand) === -1) {
            this.selectedBrands.push(val[i].brand)
            console.log('val[i].brand 222 === ' + val[i].brand)
          }
          this.netCbm = this.netCbm + val[i].volumn
          var schDate = this.dateFormat2(val[i].schDate)
          console.log('val[i].incotermCity === ' + val[i].incotermCity)
          if (this.selectedIncotermCity.indexOf(val[i].incotermCity) === -1) {
            this.selectedIncotermCity.push(val[i].incotermCity)
          }
          console.log('val[i].deliveryAddr === ' + val[i].deliveryAddr)
          if (this.selectedDeliveryAddress.indexOf(val[i].deliveryAddr) === -1) {
            this.selectedDeliveryAddress.push(val[i].deliveryAddr)
          }

          var deliveryAddrTmp = val[i].deliveryAddr
          if (val[i].brand === 'HOL' || val[i].brand === 'GUESS' || val[i].brand === 'ODLR') {
            if (val[i].deliveryAddr === 'AD_2' || val[i].deliveryAddr === 'IP DAYTON') {
              deliveryAddrTmp = 'GEN'
            }
          }
          if (val[i].brand === 'AF' || val[i].brand === 'AP' || val[i].brand === 'AS' || val[i].brand === 'BB' || val[i].brand === 'BEBE' || val[i].brand === 'BEBE' ||
          val[i].brand === 'DKNY' || val[i].brand === 'DUN' || val[i].brand === 'FC' || val[i].brand === 'FCUK' || val[i].brand === 'FER' ||
          val[i].brand === 'GRAFF' || val[i].brand === 'JPF' || val[i].brand === 'MCM' || val[i].brand === 'MULTI' || val[i].brand === 'TJMAXX' ||
          val[i].brand === 'UNG') {
            if (val[i].deliveryAddr === 'AD_2') {
              deliveryAddrTmp = 'IP DAYTON'
            }
          }
          this.rgl = { idx: this.index, id: val[i].id, status: val[i].status, schDate: schDate, schQ: val[i].schQ, schSeq: val[i].schSeq, supplier: val[i].supplier, brand: val[i].brand, intnlRef: val[i].intnlRef, item: val[i].item, itemDesc: val[i].itemDesc, length: val[i].length, width: val[i].width, height: val[i].height, carton: val[i].carton, nw: val[i].nw, gw: val[i].gw, volumn: val[i].volumn, soldTo: val[i].soldTo, deliveryAddr: deliveryAddrTmp, incotermCity: val[i].incotermCity, orderNo: val[i].orderNo, line: val[i].line, srf: '', freightCost: '', freightForwName: '', palletNum: '', currency: '', approval: true, approvalDate: new Date(), shipOut: false, finalDeliveryAddr: val[0].deliveryAddr, finalIncotermCity: this.selectedIncotermCity[0], etd: null, packingListNbr: '', eta: null, customerCd: '', flag: 'view' }
          this.multipleSelection.push(this.rgl)
          this.index++
        }

        this.cbmNoPrecise = this.netCbm
        this.netCbm = Math.round(this.netCbm * 100) / 100
        this.grossCbm = Math.round(this.cbmNoPrecise * 1.18 * 100) / 100
      }
    },
    onSubmit () {
      console.log('submit!')
      this.formInline.page = 1
      this.getRfqForwarderList()
    },
    exportToExcel () {
      /* 表示在当前页面打开新地址 */
      window.open('https://www.myirequest.com:8081/show/exportReadygoods?token=' + encodeURIComponent(this.formInline.token) +
        '&status=' + this.formInline.status + '&supplier=' + this.formInline.supplier + '&brand=' +
        this.formInline.brands + '&item=' + this.formInline.item + '&itemDesc=' + this.formInline.itemDesc, '_parent')
    },
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      // console.log('row.rowIndex === ' + this.multipleSelection.length)
      // console.log('columnIndex === ' + columnIndex)
      if ((columnIndex >= 20 && columnIndex !== 37) && rowIndex === 0) {
        return {
          rowspan: this.multipleSelection.length,
          colspan: 1
        }
      }
      if (rowIndex >= 1 && (columnIndex >= 20 && columnIndex !== 37)) {
        return {
          rowspan: 0,
          colspan: 0
        }
      }
    },
    async getRfqForwarderList () {
      var statusStr = ''
      if (this.formInline.status && this.formInline.status.length) {
        this.formInline.status = [...this.formInline.status].join(',')
        statusStr = this.formInline.status
      }
      var brandsStr = ''
      if (this.formInline.brands && this.formInline.brands.length) {
        this.formInline.brands = [...this.formInline.brands].join(',')
        brandsStr = this.formInline.brands
      }
      var soldToStr = ''
      if (this.formInline.soldTos && this.formInline.soldTos.length) {
        this.formInline.soldTos = [...this.formInline.soldTos].join(',')
        soldToStr = this.formInline.soldTos
      }
      var deliveryAddrStr = ''
      if (this.formInline.deliveryAddr && this.formInline.deliveryAddr.length) {
        this.formInline.deliveryAddr = [...this.formInline.deliveryAddr].join(',')
        deliveryAddrStr = this.formInline.deliveryAddr
      }
      const { data: res } = await this.$http.get('/show/rfqReadygoodsList', { params: this.formInline })
      this.readygoodsList = res.rows
      this.total = res.total

      if (res.rows && this.readygoodsList[0]) {
        this.updateTime = this.readygoodsList[0].createTime
      }
      if (statusStr !== '') {
        await this.$set(this.formInline, 'status', statusStr.split(','))
      }
      if (brandsStr !== '') {
        await this.$set(this.formInline, 'brands', brandsStr.split(','))
      }
      if (soldToStr !== '') {
        await this.$set(this.formInline, 'soldTos', soldToStr.split(','))
      }
      if (deliveryAddrStr !== '') {
        await this.$set(this.formInline, 'deliveryAddr', deliveryAddrStr.split(','))
      }
    },
    numFormat (row, column, cellValue, index) {
      var numrc = row[column.property]
      if (numrc === null || numrc === '') {
        return
      }
      if (numrc.toString().indexOf('.') === -1) {
        return numrc
      }
      var result = ''
      var numrcStr = numrc.toString()
      numrc = numrcStr.substring(0, numrcStr.indexOf('.') + 3)
      return result
    },
    dateFormat (row, column, cellValue, index) {
      const daterc = row[column.property]
      if (daterc === null || daterc === '' || daterc === undefined || daterc === '' || daterc === '1753/01/01 00:00:00' ||
      daterc === '1753-01-01 00:00:00') {
        return
      }
      var date = new Date(daterc) // long转换成date
      var year = date.getFullYear().toString()
      var month = (date.getMonth() + 1)
      var day = date.getDate().toString()
      // if (month < 10) {
      //   month = '0' + month
      // }
      var monthLetterArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      var monthLetter = monthLetterArr[parseInt(month) - 1]
      if (day < 10) {
        day = '0' + day
      }
      return year + '-' + monthLetter + '-' + day
    },
    dateFormat1 (daterc) {
      // const daterc = row[column.property]
      console.log('daterc === ' + daterc)
      if (daterc === null || daterc === '' || daterc === undefined || daterc === '1753/01/01 00:00:00' || daterc === '1753-01-01 00:00:00') {
        return
      }
      var date = new Date(daterc) // long转换成date
      var year = date.getFullYear().toString()
      var month = (date.getMonth() + 1)
      var day = date.getDate().toString()
      // if (month < 10) {
      //   month = '0' + month
      // }
      var monthLetterArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      var monthLetter = monthLetterArr[parseInt(month) - 1]
      if (day < 10) {
        day = '0' + day
      }
      return year + '-' + monthLetter + '-' + day
    },
    dateFormat2 (daterc) {
      // const daterc = row[column.property]
      if (daterc === null || daterc === '' || daterc === '1753/01/01 00:00:00' || daterc === '1753-01-01 00:00:00') {
        return
      }
      var date = new Date(daterc) // long转换成date
      var year = date.getFullYear().toString()
      var month = (date.getMonth() + 1)
      var day = date.getDate().toString()
      // if (month < 10) {
      //   month = '0' + month
      // }
      var monthLetterArr = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']
      var monthLetter = monthLetterArr[parseInt(month) - 1]
      if (day < 10) {
        day = '0' + day
      }
      return year + '-' + monthLetter + '-' + day
    },
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`)
      this.formInline.rows = val
      this.getRfqForwarderList()
    },
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`)
      this.formInline.page = val
      this.getRfqForwarderList()
    },
    getMonth (month) {
      var monthLetter
      switch (month) {
        case '01':
          monthLetter = 'Jan'
          break
        case '02':
          monthLetter = 'Feb'
          break
        case '03':
          monthLetter = 'Mar'
          break
        case '04':
          monthLetter = 'Apr'
          break
        case '05':
          monthLetter = 'May'
          break
        case '06':
          monthLetter = 'Jun'
          break
        case '07':
          monthLetter = 'Jul'
          break
        case '08':
          monthLetter = 'Aug'
          break
        case '09':
          monthLetter = 'Sep'
          break
        case 10:
          monthLetter = 'Oct'
          break
        case 11:
          monthLetter = 'Nov'
          break
        case 12:
          monthLetter = 'Dec'
          break
      }
      return monthLetter
    }

    // dateFormat (value) {
    //   if (value === null || value === '') {
    //     return ''
    //   }
    //   var date = new Date(value) // long转换成date
    //   var year = date.getFullYear().toString()
    //   var month = (date.getMonth() + 1)
    //   var day = date.getDate().toString()
    //   if (month < 10) {
    //     month = '0' + month
    //   }
    //   if (day < 10) {
    //     day = '0' + day
    //   }
    //   return year + '/' + month + '/' + day
    // }
  }
}
</script>

<style>
</style>
